import { useRef, useState } from 'react'
import DatePicker from 'react-datepicker'
// import { useSearchParams } from 'react-router-dom'

import { Header } from './Header.js'
import { Footer } from './Footer.js'

import './Book.css'

import "react-datepicker/dist/react-datepicker.css";

export function Book () {
  // const [searchParams] = useSearchParams()

  // const theme = searchParams.get('theme')
  // const packageType = searchParams.get('packageType')

  const [dateTime, setDateTime] = useState()
  const [location, setLocation] = useState('')
  const [fullName, setFullName] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [email, setEmail] = useState('')
  const [confirmationVisible, setConfirmationVisible] = useState(false)
  const locationTextBoxRef = useRef(null)

  async function handleSubmit (e) {
    e.preventDefault()

    await fetch('https://api.fernandfablepicnics.com/book', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        fullName,
        phoneNumber,
        email,
        location,
        dateTime
      })
    })

    setConfirmationVisible(true)
  }

  return (
    <div>
      <Header activeItem='book' />
      <main>
        <section className='booking-section'>
          <div className='container'>
            <form className='form-group' onSubmit={handleSubmit}>
              <h1 id='bookHeader'>Book Your Event</h1>
              <DatePicker
                selected={dateTime}
                onChange={(date) => {
                  setDateTime(date)
                  locationTextBoxRef.current.focus()
                }}
                showTimeSelect
                dateFormat="MMM dd, YYYY h:mm aa"
                shouldCloseOnSelect
                placeholderText="Date/Time"
                className='datePicker'
              />
              <input
                className='location'
                ref={locationTextBoxRef}
                type='text'
                placeholder='Where you would like your picnic'
                value={location}
                onChange={evt => {
                  setLocation(evt.target.value)
                }}
              />
              <input
                className='fullName'
                type='text'
                placeholder='Your name'
                value={fullName}
                onChange={evt => {
                  setFullName(evt.target.value)
                }}
              />
              <input
                className='phoneNumber'
                type='tel'
                placeholder='Your phone number'
                value={phoneNumber}
                onChange={evt => {
                  setPhoneNumber(evt.target.value)
                }}
              />
              <input
                className='email'
                type='email'
                placeholder='Your email address'
                value={email}
                onChange={evt => {
                  setEmail(evt.target.value)
                }}
              />
              <button
                disabled={!dateTime || !location || !email || !phoneNumber || !fullName}
                type='submit'
              >
                Request Booking
              </button>

              {confirmationVisible && (
                <div className="confirmation">Thank you! We'll contact you soon to confirm your reservation.</div>
              )}
            </form>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}
